import React from 'react';
import { Panel, PanelTheme, PanelBorderRadius } from '@apply/components';
import '../scss/_homepanels.scss';
import { Button, ButtonTheme } from '@apply/components';
import { useNavigate } from 'react-router-dom';
import { BusinessAndPeopleApi } from '@apply/api/src/api/BusinessAndPeopleApi';
import { applicationInsights } from '../../ApplicationInsights';
import { alertModal } from '@apply/ui';
import { useAuthentication } from '../../LoginPage';
import { FeatureType } from '@apply/constants';
import { useDispatch } from 'react-redux';
import { updateApiId } from '@apply/store/src/borrower/actions';

export const NewApplicationPanel: React.FC = () => {
    const dispatch = useDispatch();
    const businessAndPeopleApi = new BusinessAndPeopleApi(applicationInsights);

    const navigate = useNavigate();
    const { isFeatureEnabled } = useAuthentication();

    const loadUserBusinesses = async () => {
        try {
            const responseBusinesses = await businessAndPeopleApi.getBorrowerBusinesses();
            if (responseBusinesses.statusCode !== 200) {
                alertModal({
                    message: 'Failed to load Borrower Business Information. Please try again.',
                });
            }

            const result = responseBusinesses.result;
            if (result && result.length == 0) {
                navigate(`/business?redirectTo=/borrower`);
            } else {
                navigate('/borrower');
            }
        } catch {
            alertModal({
                message: 'Failed to load Borrower Entities. Please try again.',
            });
        }
    };
    const onNewApplication = () => {
        // BFIA-4083 Wipe the apiId so we do not accidently reuse the same appliation. We want a new one.
        dispatch(updateApiId(''));

        //Check if feature flag is enabled
        if (!isFeatureEnabled(FeatureType.BPHierarchyPhase1)) {
            navigate('/borrower');
        } else {
            //Check to see if a top level business exists
            loadUserBusinesses();
        }
    };
    return (
        <Panel
            theme={PanelTheme.Blue}
            borderRadius={PanelBorderRadius.Medium}
        >
            <div className='panelContent newApplication'>
                <h3>Apply</h3>
                <div className='homeNewApplicationButtonDiv'>
                    <Button
                        id='homeNewApplicationButton'
                        theme={ButtonTheme.Primary}
                        handleClick={onNewApplication}
                        width='95%'
                    >
                        New Application
                    </Button>
                </div>
            </div>
        </Panel>
    );
};
